import script from "./PromotionA.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionA.vue?vue&type=script&setup=true&lang=js"

import "./PromotionA.vue?vue&type=style&index=0&id=64749351&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64749351"]])

export default __exports__